import { useNaptime } from 'bundles/naptimejs';
import ProgramCurriculumsV1 from 'bundles/naptimejs/resources/programCurriculums.v1';

const useGetProgramCurriculumQuery = ({ curriculumId }: { curriculumId?: string }) => {
  const {
    data: { curriculum },
    pending,
  } = useNaptime<{ curriculum?: ProgramCurriculumsV1 | null }>(
    () => ({
      curriculum: curriculumId
        ? ProgramCurriculumsV1.get(curriculumId, {
            fields: ['definition'],
          })
        : undefined,
    }),
    [curriculumId]
  );

  return {
    curriculum,
    loading: pending,
  };
};

export default useGetProgramCurriculumQuery;
